import { render, staticRenderFns } from "./BiographyCover.vue?vue&type=template&id=334e6f0e&scoped=true"
import script from "./BiographyCover.vue?vue&type=script&lang=js"
export * from "./BiographyCover.vue?vue&type=script&lang=js"
import style0 from "./BiographyCover.vue?vue&type=style&index=0&id=334e6f0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334e6f0e",
  null
  
)

export default component.exports